import React, { Component } from 'react';

/* 개발담당:양유빈
 * 화면기능:고객센터
 * 세부설명:
*/

export class ServiceCenter extends Component {
    static displayName = ServiceCenter.name;

    constructor(props) {
        super(props);
        this.state = {
        };
    }
    //초기화
    componentDidMount() {
    }

    handle_Location = (event) => {
        window.open('https://pf.kakao.com/_GxixbKG', "_blank");
        event.preventDefault();
    }

    render() {
        return (
            <div className="container_box p_b_margin u_padding ">
                <div className="mypage_info">
                    <div className="shop_name">고객센터 운영시간</div>
                    <div className="shop_retail">평일 주간 : 09:00 ~ 06:00</div>
                    <div className="shop_retail">채팅 상담 : 09:00 ~ 06:00</div>
                    <div className="mypage_icon_menu service_box">
                        <div className="service_icon_box">
                            <div className="call_icon"></div>
                            <div className="txt">전화상담</div>
                        </div>
                        <div className="service_icon_box" onClick={(e) => { this.handle_Location(e) }}>
                            <div className="kakao_icon"></div>
                            <div className="txt">카카오상담</div>
                        </div>
                    </div>
                </div>
                <div className="mypage_info">
                    <div className="my_page_menu_title">FAQ</div>
                    <div className="my_page_menu">상품등록</div>
                    <div className="my_page_menu">주문관련</div>
                    <div className="my_page_menu">거래처관리</div>
                </div>
                <div className="mypage_info bn">
                    <div className="my_page_menu_title pointer"
                        onClick={(event) => { this.props.RenderComponent('Withdrawal'); event.preventDefault();}}
                    >회원탈퇴</div>
                </div>
            </div>
        );
    }
}
